import React, { FC } from 'react';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { getResponsiveStyle } from '@utils/responsive';
import styles from './HorizontalSlider.module.css';

interface HorizontalSliderBreakpointsStylesProps {
    height?: string;
    itemsWidth?: string;
    itemsGap?: string;
}

export interface HorizontalSliderProps {
    // styles apply from breakpoint up
    breakpointsStyles: {
        xs?: HorizontalSliderBreakpointsStylesProps;
        sm?: HorizontalSliderBreakpointsStylesProps;
        md?: HorizontalSliderBreakpointsStylesProps;
        lg?: HorizontalSliderBreakpointsStylesProps;
        xl?: HorizontalSliderBreakpointsStylesProps;
        xxl?: HorizontalSliderBreakpointsStylesProps;
    };
    children: JSX.Element | JSX.Element[];
}

export const HorizontalSlider: FC<HorizontalSliderProps> = ({ breakpointsStyles, children }) => {
    const pageSize = useMediaQuery();

    const height = getResponsiveStyle('height', pageSize, breakpointsStyles);
    const itemsGap = getResponsiveStyle('itemsGap', pageSize, breakpointsStyles);
    const itemsWidth = getResponsiveStyle('itemsWidth', pageSize, breakpointsStyles);

    const horizontalContentWidth100ContainerStyle = {
        height: `${height}`,
    };

    const horizontalContentStyle = {
        marginTop: `${height}`,
        width: `${height}`,
        gap: `${itemsGap}`,
    };

    const itemsStyle = {
        width: `${itemsWidth}`,
        height: `${itemsWidth}`,
    };

    const contentOffsetStyle = {
        height: `${height}`,
    };

    return (
        <>
            <div
                style={horizontalContentWidth100ContainerStyle}
                className={styles['horizontal-content-width100-container']}
                data-testid="horizontal-slider">
                <div className={styles['horizontal-content-container']}>
                    <div style={horizontalContentStyle} className={styles['horizontal-content']}>
                        {Array.isArray(children)
                            ? children.map((child, index) => (
                                  <div key={`item-${index}`} style={itemsStyle}>
                                      {child}
                                  </div>
                              ))
                            : children}
                    </div>
                </div>
            </div>
            <div style={contentOffsetStyle}></div>
        </>
    );
};
